import React from "react";

const Subtitle: React.FC = () => {
    return (
        <>
            See how average yearly visits per cell in the selected retail centre compare to your target.
            This helps you understand whether the location meets your expectations for shopper activity.
        </>
    );
};

export default Subtitle;
